import { Command } from 'ckeditor5/src/core';
import { findDescendant } from '../utils';
import { CHECKBOX_ATTR_ID, COMPONENT_ATTR_CAN_REVIEW, COMPONENT_ATTR_NEW_VALUE, COMPONENT_NAME, CHECKBOX_OUT_COMMANDS } from '../constants';
import { isNil } from 'lodash';

export default class CheckBoxDiffBulkCommand extends Command {
	execute( data ) {
		if ( !data || isNil( data.fields ) ) {
			return;
		}

		const checkboxes = data.fields;
		const canReview = data.canReview;
		const editor = this.editor;

		if ( !Array.isArray( checkboxes ) ) {
			this.fire( CHECKBOX_OUT_COMMANDS.DIFF_BULK, {
				message: 'Checkboxes should be array',
				type: 'error'
			} );
			return;
		}

		if ( checkboxes.length === 0 ) {
			this.fire( CHECKBOX_OUT_COMMANDS.DIFF_BULK, {
				message: 'Checkboxes length is 0',
				type: 'error'
			} );
			return;
		}

		editor.model.change( writer => {
			checkboxes.forEach( ( { name, newValue } ) => {
				const elements = findDescendant( editor.model.document.getRoot(), element => {
					return (
						element &&
						element.is( 'element', COMPONENT_NAME ) &&
						element.getAttribute( CHECKBOX_ATTR_ID ) === name
					);
				} );
				if ( elements.length > 0 ) {
					elements.forEach( elem => {
						writer.setAttribute( COMPONENT_ATTR_NEW_VALUE, newValue, elem );
						writer.setAttribute( COMPONENT_ATTR_CAN_REVIEW, canReview, elem );
					} );
				}
				this.fire( CHECKBOX_OUT_COMMANDS.DIFF_BULK, { type: 'ok' } );
			} );
		} );
	}
}
